import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

// The registry version of this file reaches for `next-themes`. We do not have (or want) a
// ThemeProvider — dark mode here is the `.dark` class on <html>, which is what Tailwind already
// keys off. Sonner's own `system` default follows prefers-color-scheme, which is the same answer
// without the dependency.
const Toaster = ({ ...props }: ToasterProps): React.JSX.Element => (
  <Sonner
    className="toaster group"
    toastOptions={{
      classNames: {
        toast:
          'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
        description: 'group-[.toast]:text-muted-foreground',
        actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
        cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
      },
    }}
    {...props}
  />
);

export { Toaster };
